// extracted by mini-css-extract-plugin
export default {"TwitchVideoEmbed":"TwitchVideo_TwitchVideoEmbed__KYW4p"};